import { Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import Chips from "./Chips";
import { useAppSelector } from "../../../app/hooks";
import { Skill } from "../../orders/orderAPI";
import { groupSkills, SkillGroups } from "../LocalizedGroups";

type FormProps = {
  skills: Skill[];
  removeSkillCallback: (skillId: string) => void;
  disableRemove?: boolean;
};

const SkillRows = ({
  skills,
  removeSkillCallback,
  disableRemove = false,
}: FormProps) => {
  const localizedSkillIds = useAppSelector((state) => state.localized?.skill);
  const localizedFieldOfWorkIds = useAppSelector(
    (state) => state.localized?.fieldOfWork,
  );

  let groups: SkillGroups = groupSkills(skills, {
    skillId: localizedSkillIds,
    fieldOfWorkId: localizedFieldOfWorkIds,
  });

  groups = Object.fromEntries(
    Object.entries(groups).sort(([a], [b]) => a.localeCompare(b)),
  ) as SkillGroups;

  return (
    <>
      <Grid container columnSpacing={2} rowSpacing={2}>
        {Object.entries(groups).map(
          ([localizedFieldOfWork, localizedSkills]) => (
            <Fragment key={localizedFieldOfWork}>
              <Grid
                item
                container
                xs={3}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Typography textAlign="end" variant="secondary">
                  {localizedFieldOfWork}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Chips
                  localizedSkills={localizedSkills.sort((a, b) =>
                    a.name.localeCompare(b.name),
                  )}
                  onDelete={!disableRemove ? removeSkillCallback : undefined}
                ></Chips>
              </Grid>
            </Fragment>
          ),
        )}
      </Grid>
    </>
  );
};

export default SkillRows;
